import React, { Component, useState, useEffect  } from "react";
import DatePicker from "react-datepicker";
import { Container,Col,Tabs,Tab,Badge,Table,Button,Pagination,FormControl,Row,ToggleButton,ButtonGroup,Dropdown } from 'react-bootstrap';
import { ContainerHeader,Content,ContainerWrapper,ContainerBody } from '../../../components/GridComponent/AdminLte.js';
// import "./DtrMultiLogsSummary.css";
import { Formik,FieldArray,Field,ErrorMessage,getIn  } from 'formik';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import Wrapper from "../../../components/Template/Wrapper/index.js";
import { InputDate,InputTime   } from '../../../components/DatePickerComponent/DatePicker.js';
import { fetchDtrMultiLogs, exportDtrMultiLogs } from '../../../store/actions/dtr/dtrSummaryActions.js';
import { Form  } from 'react-bootstrap';
import Authenticator from "../../../services/Authenticator.js";

class DtrMultiLogs extends Component {

  constructor(props){
    super(props);
    //Added status filter for employment status
    this.state = {
      initialState : {
        valid_from: ( this.props.settings?.current_payroll_cutoff?.start_date ? new Date( this.props.settings.current_payroll_cutoff.start_date) : null),
        valid_to:   ( this.props.settings?.current_payroll_cutoff?.end_date ? new Date( this.props.settings.current_payroll_cutoff.end_date) : null),
        department_id: null,
        category_id: null,
        task_id: null,
        name: null,
        is_active: 1,
        export: false
      }
    }; 
  }

  componentDidMount() {
    if ((this.props.user) && (this.props.user.sub_departments_handled.length > 0)) {
      if (!this.state.initialState.department_id) {
        this.setState({ initialState: {
          ...this.state.initialState,
          department_id: this.props.user.sub_departments_handled[0].Id
        }}, () => {
          if (this.state.initialState.valid_from && this.state.initialState.valid_to)
          this.onSubmitHandler(this.state.initialState);
        });
      }
    }
  }

  onSubmitHandler = (values) => {
    var formData = {};
    for (var key in values) {
      if( values[key] != null && values[key] != ""  ) {
        switch( key ) {
          case "valid_from":
          case "valid_to":
            formData[key] = moment( values[key] ).format("YYYY-MM-DD")
            break;
          case "export":
            break;
          default:
            formData[key] = values[key];
            break;
          }
      } 
    }

    if (values.export == "all_new") {
      var formData = {};
      for (var key in values) {
        if( values[key] != null && values[key] != ""  ) {
          switch( key ) {
            case "valid_from":
            case "valid_to":
              formData[key] = moment( values[key] ).format("YYYY-MM-DD")
              break;
            case "department_id":
            case "name":
              break;
            default:
              formData[key] = values[key];
              break;
          }
        } 
      }

      this.props.exportDtrMultiLogs( formData );

    } else if (values.export == "department_new") {
      var formData = {};
      for (var key in values) {
        if( values[key] != null && values[key] != ""  ) {
          switch( key ) {
            case "valid_from":
            case "valid_to":
              formData[key] = moment( values[key] ).format("YYYY-MM-DD")
              break;
            case "name":
              break;
            default:
              formData[key] = values[key];
              break;
          }
        } 
      }

      this.props.exportDtrMultiLogs( formData );

    } else {
      this.props.fetchDtrMultiLogs( formData );
    }
  }

	render = () => {  
    var column = [];
 
    return (<Formik 
      enableReinitialize
      onSubmit={this.onSubmitHandler} 
      validationSchema={validationSchema} 
      initialValues={this.state.initialState}>
		{
		({values,errors,setFieldValue,field,touched,handleSubmit,handleReset,handleChange}) => {

      const filteredProjects = this.props.user.projects_mc.filter(
        item => item.evox_sub_department_id == values.department_id
      );

      const filteredTasks = this.props.user.tasks_mc.filter(
        item => item.category_id == values.category_id
      );

      return (
      <form onSubmit={handleSubmit}>
        <Wrapper {...this.props} >
          <ContainerWrapper>  
            <h2 className="page-title">DTR MULTI CLOCK LOGS</h2>
            <Row className="filters filter-dtr"> 
              <Col className="date-range"> 
                <div className="form-group">
                  <label>Date Range:</label>
                  <InputDate name="valid_from" value={values.valid_from}/>
                  <InputDate name="valid_to" value={values.valid_to}/>
                </div>
              </Col>  
                        
              <Col className="dept"> 
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <select
                        className="form-control" 
                        name="department_id"
                        value={values.department_id}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('category_id', '');
                          setFieldValue('task_id', '');
                        }}
                        style={{ display: 'block' }}
                      >
                        <option label="- Department -" />
                        {this.props.user.sub_departments_handled.map(function(item){
                          return <option value={item.Id} label={item.Name} />;
                        })}
                      </select>
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage component="div" name="department_id" className="input-feedback" />
                      </Form.Control.Feedback> 
                    </div>
                  </div>
                
                  <div className="col-md-4">
                    <div className="form-group">
                      <select
                        className="form-control" 
                        name="category_id"
                        value={values.category_id}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue('task_id', '');
                        }}
                        style={{ display: 'block' }}
                      >
                        <option value="" label="All" />
                        {filteredProjects.map(function(item){
                          return <option key={item.id} value={item.id} label={item.name} />;
                        })}
                      </select>
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage component="div" name="category_id" className="input-feedback" />
                      </Form.Control.Feedback> 
                    </div>  
                  </div>
                
                  <div className="col-md-4">
                    <div className="form-group">
                      <select
                        className="form-control" 
                        name="task_id"
                        value={values.task_id}
                        onChange={handleChange}
                        style={{ display: 'block' }}
                      >
                        <option value="" label="All" />
                        {filteredTasks.map(function(item){
                          return <option key={item.id} value={item.id} label={item.name} />;
                        })}
                      </select>
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage component="div" name="task_id" className="input-feedback" />
                      </Form.Control.Feedback> 
                    </div>  
                  </div>
                </div>
              </Col>

              <Col className="btns filter-button">   
                <div className="form-group">
                  <Button id="btn-generate" variant="primary" type="submit" onClick={() => setFieldValue("export", false)}><i className="fa fa-newspaper-o" /> Generate</Button>&nbsp;&nbsp;
                  { Authenticator.scanFeature('export_dtr_summary') &&
                    <Button id="btn-generate" variant="primary" type="submit" onClick={() => setFieldValue("export", "department_new")}><i className="fa fa-download" /> Export</Button>
                  }
                </div>
              </Col>
            </Row>

            <div className="content-table">
              { this.props.dtrMultiLogs.isListLoaded? (<Row><div className="dtr-summary-table">

              <table class="table dtrSummary">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" class="th-id">Employee Number</th>
                    <th scope="col" class="th-name">Employee Name</th>
                    <th scope="col">Activity</th>
                    <th scope="col">Sub-Activity</th>
                    <th scope="col">Date</th>
                    <th scope="col">Time Start</th>
                    <th scope="col">Time End</th>
                    <th scope="col">Hours Spent</th>
                    <th scope="col">Notes</th>
                  </tr>
                </thead>

                <tbody>
                  {this.props.dtrMultiLogs.dtrItems.map((list, index) => {
                    var holiday = [];
                    return <tr>
                      <td>{list.Employee_Number}</td>
                      <td>{list.Employee_Name}</td>
                      <td>{list.Category_Name}</td>
                      <td>{list.Task_Name}</td>
                      <td>{list.Date}</td>
                      <td>{moment(list.Time_In, "HH:mm:ss").format("hh:mm:ss A")}</td>
                      <td>{moment(list.Time_Out, "HH:mm:ss").format("hh:mm:ss A")}</td>
                      <td>{list.Total_Hours}</td>
                      <td>{list.Remarks}</td>
                    </tr>
                  })}
                </tbody>
              </table>

              {/* <Paginate pagination={request_list} /> */}
              </div></Row>) : (<div className="pd20">Sorry , no record found</div>)}    
            </div>
          </ContainerWrapper>
        </Wrapper>
      </form>
		)}}
		</Formik>);
	}
}

const validationSchema = Yup.object().shape({
  valid_from:      		Yup.date().required("This field is required").nullable().max( Yup.ref('valid_to') , 'Please select a Valid From date.'),
  valid_to:     			Yup.date().required("This field is required").nullable().min( Yup.ref('valid_from') , 'Please select a Valid To date.'),
  department_id:  		Yup.string().required("This field is required"),
});

const mapStateToProps = (state) => {
  return {
    dtrMultiLogs  : state.dtrMultiLogs,
    settings  : state.settings
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
  fetchDtrMultiLogs : ( params ) => dispatch( fetchDtrMultiLogs(  params ) ),
  exportDtrMultiLogs : ( params ) => dispatch( exportDtrMultiLogs( params ) ),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DtrMultiLogs);

  